export const set_val= {
    1:[
        {
            value:25
        },
    ],
    2:[
        {
            label:'关机',
            value:0
        },
        {
            label:'开机',
            value:1
        },
    ],
    3:[
        {
            label:'制热',
            value:1
        },
        {
            label:'制冷',
            value:3
        },
        {
            label:'通风',
            value:9
        },
    ],
    5:[
        {
            label:'低速',
            value:1
        },
        {
            label:'高速',
            value:2
        },
        {
            label:'中速',
            value:3
        },
        {
            label:'自动',
            value:4
        },
    ],
    6:[
        {
            label:'关',
            value:0
        },
        {
            label:'开',
            value:1
        },
    ],
    34:[
        {
            label:'开锁',
            value:0
        },
        {
            label:'锁定',
            value:1
        },
    ],
}